
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_dud7m_13",
  "fit-height": "awsui_fit-height_14iqq_dud7m_46",
  "with-side-media": "awsui_with-side-media_14iqq_dud7m_51",
  "variant-default": "awsui_variant-default_14iqq_dud7m_54",
  "variant-stacked": "awsui_variant-stacked_14iqq_dud7m_54",
  "refresh": "awsui_refresh_14iqq_dud7m_63",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_dud7m_113",
  "with-stuck-sticky-header-at-bottom": "awsui_with-stuck-sticky-header-at-bottom_14iqq_dud7m_119",
  "focus-ring": "awsui_focus-ring_14iqq_dud7m_126",
  "with-top-media": "awsui_with-top-media_14iqq_dud7m_150",
  "content-wrapper": "awsui_content-wrapper_14iqq_dud7m_155",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_dud7m_160",
  "media": "awsui_media_14iqq_dud7m_167",
  "media-top": "awsui_media-top_14iqq_dud7m_185",
  "media-side": "awsui_media-side_14iqq_dud7m_190",
  "header": "awsui_header_14iqq_dud7m_196",
  "header-full-page": "awsui_header-full-page_14iqq_dud7m_201",
  "header-variant-embedded": "awsui_header-variant-embedded_14iqq_dud7m_204",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_dud7m_204",
  "header-with-media": "awsui_header-with-media_14iqq_dud7m_207",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_dud7m_213",
  "header-stuck": "awsui_header-stuck_14iqq_dud7m_223",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_dud7m_233",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_dud7m_236",
  "with-paddings": "awsui_with-paddings_14iqq_dud7m_242",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_dud7m_251",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_dud7m_309",
  "header-cover": "awsui_header-cover_14iqq_dud7m_312",
  "content": "awsui_content_14iqq_dud7m_155",
  "content-fit-height": "awsui_content-fit-height_14iqq_dud7m_340",
  "content-inner": "awsui_content-inner_14iqq_dud7m_346",
  "with-header": "awsui_with-header_14iqq_dud7m_353",
  "footer": "awsui_footer_14iqq_dud7m_357",
  "with-divider": "awsui_with-divider_14iqq_dud7m_361"
};
  